const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

const phases = [
  {
    phase: 'PHASE 1: HEALED',
    weeks: 'Weeks 1–3',
    details: 'Nervous system · Safety · Somatic awareness · Survival patterns',
  },
  {
    phase: 'PHASE 2: OWNED',
    weeks: 'Weeks 4–6',
    details: 'Mother wound · Father wound · Authority · Worth · Inner leadership',
  },
  {
    phase: 'PHASE 3: MET',
    weeks: 'Weeks 7–9',
    details: 'Self-love · Internal validation · Money · Shadow · Power · Desire',
  },
  {
    phase: 'PHASE 4: EMBODIED',
    weeks: 'Weeks 10–12',
    details: 'Womb work · Feminine safety · New patterns · Integration',
  },
];

export default function Offer3Section() {
  return (
    <section className="bg-[#FDFAF8]">
      {/* Content */}
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto py-16 md:py-24">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
          The 12-week healing protocol
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] mb-4 leading-tight">
          H.O.M.E. Healed. Owned. Met. Embodied.
        </h2>

        {/* Body */}
        <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-12">
          HOME is Mandie's signature 12-week self-paced healing protocol with live support, taking women through every layer of their inner world, week by week, room by room.
        </p>

        {/* Timeline */}
        <div className="relative">
          {/* Gold connector line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-[#C9A84C]/40" />

          <div className="space-y-8">
            {phases.map((p) => (
              <div key={p.phase} className="relative flex gap-6 md:gap-8">
                {/* Timeline dot */}
                <div className="relative flex-shrink-0">
                  <div className="w-8 h-8 md:w-12 md:h-12 rounded-full bg-[#C9A84C] flex items-center justify-center">
                    <i className="ri-check-line text-[#1A1A1A] text-sm md:text-base" />
                  </div>
                </div>

                {/* Content */}
                <div className="pb-2">
                  <p className="text-[#C9A84C] text-xs font-body font-medium mb-1">
                    {p.weeks}
                  </p>
                  <h3 className="font-heading text-lg text-[#1A1A1A] mb-2">
                    {p.phase}
                  </h3>
                  <p className="font-body text-sm text-[#5A5A5A]">
                    {p.details}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12">
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 w-full sm:w-auto"
          >
  Book a Clarity Call
</a>
<p className="text-xs text-[#4A4A4A] mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#D4006A]">Book a Private Clarity Call</a>
</p>
        </div>
      </div>
    </section>
  );
}